import PageError from '@zenbusiness/zui/PageError';

export default function ErrorPage({ children }) {
  return <PageError>{children}</PageError>;
}
